<template>
  <!-- 巡检数据 -->
  <div>
    <HeadControl ref="headControl" :titleName="'巡检数据'" @changeVal="changeVal" @changDate="changDate" @changePicker="changePicker" />
    <div class="wrap">
      <div class="top">
        <div class="t_left">
          <div class="checkWrap" v-for="(item, index) in checkProjectData.reportList" :key="index">
            <div class="image">
              <img :src="item.itemIcon" />
            </div>
            <div class="info">
              <div class="total">{{ item.itemName }}</div>
              <div class="number">
                <span class="num">{{ item.count }}</span>个
              </div>
            </div>
          </div>
        </div>
        <div class="checkProject" ref="checkProject"></div>
      </div>
      <div class="center">
        <div class="c_left">
          <div class="left_top">
            <div class="itemWrap" v-for="(item, index) in projectDataList" :key="index">
              <div class="item">
                <div class="total">{{ item.itemName }}</div>
                <div class="number">
                  <span class="num">{{ item.count }}</span>个
                </div>
              </div>
            </div>
          </div>
          <div class="left_bottom">
            <div class="p_title">项目地区</div>
            <div class="areaWrap" v-for="(item, index) in regionDataList" :key="index">
              <div class="item">
                <div class="left">
                  <div class="location">{{ item.itemName }}</div>
                  <div class="number">
                    <span class="num">{{ item.count }}</span>个
                  </div>
                </div>
                <div class="right">
                  <img :src="item.itemIcon" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="projectGrade" ref="projectLevel"></div>
      </div>
      <div class="bottom">
        <div class="projectRank">
          <div class="p_title">
            <i class="el-icon-s-data"></i>
            项目评分排行
          </div>
          <div v-if="!projectRankList.length" class="nodata_box">
            <img src="https://xmyun.zhoty.com/xmerp/pcadmin/static/images/report_item_nodata.png" alt="">
            <span>暂无数据</span>
          </div>
          <div v-else>
            <ul class="tablist">
              <li :class="{'active': activeProjectName === 'ALL'}" @click="handleClick('ALL')">总平均分</li>
              <li :class="{'active': activeProjectName === 'SECURITY'}" @click="handleClick('SECURITY')">安全评分</li>
              <li :class="{'active': activeProjectName === 'QUALITY'}" @click="handleClick('QUALITY')">质量评分</li>
            </ul>
            <table class="tablewrap">
              <tr class="table_title">
                <td class="first">项目名称</td>
                <td v-if="!$route.query.identification">项目总监</td>
                <td v-if="!$route.query.identification">检查总次数</td>
                <td class="last">总平均分</td>
              </tr>
              <tr v-for="(item,index) in projectRankList" :key="index">
                <td :class="{'first':$route.query.identification}">
                  <!-- <span class="content" style="display: flex; width:85%; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;"> -->
                  <span class="content" style="display: inline-block; width:85%; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;" >
                    <span :class="{one: item.serialNumber === 1, second: item.serialNumber === 2, third: item.serialNumber === 3}">{{item.serialNumber}}</span>　
                    <span class="showTips" v-if="TextShow && actived==index" :style="{'left': x + 'px'}">{{item.name}}</span>
                    <span @mouseover.stop="getText($event,item.name);actived=index" @mouseout.stop="TextShow = false" >
                      {{item.name}}
                    </span>
                    <!-- <TableContentOverflow :content="item.name" :num="1" :width="80"/> -->
                  </span>
                </td>
                <td class="BigshowTips" v-if="!$route.query.identification">
                  <span style="display: inline-block; width:100%; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;" >
                    <span>
                      {{item.pmName}} {{item.phone}}
                    </span>
                  </span>
                </td>
                <td v-if="!$route.query.identification">
                  <span style="display: inline-block;width:60%;text-align: center">
                    {{item.count}}
                  </span>
                </td>
                <td :class="{'last':$route.query.identification}" style="position: relative">
                  <span style="position: absolute; left: 50%; top: 0">
                    {{item.avgScore}}
                  </span>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div class="directorRank">
          <div class="p_title">
            <i class="el-icon-s-data"></i>
            总监评分排行
          </div>
          <div v-if="!directorScoreList.length" class="nodata_box">
            <img src="https://xmyun.zhoty.com/xmerp/pcadmin/static/images/report_item_nodata.png" alt="">
            <span>暂无数据</span>
          </div>
          <div v-else>
            <ul class="tablist">
              <li :class="{'active': activeDirectorName === 'ALL'}" @click="handleClick2('ALL')">总平均分</li>
              <li :class="{'active': activeDirectorName === 'SECURITY'}" @click="handleClick2('SECURITY')">安全评分</li>
              <li :class="{'active': activeDirectorName === 'QUALITY'}" @click="handleClick2('QUALITY')">质量评分</li>
            </ul>
            <table class="tablewrap directorTable">
              <tr class="table_title">
                <td class="first">项目总监</td>
                <td v-if="!$route.query.identification">工地个数</td>
                <td v-if="!$route.query.identification">检查总次数</td>
                <td class="last">总平均分</td>
              </tr>
              <tr v-for="(item,index) in directorScoreList" :key="index">
                <td :class="{'first':$route.query.identification}">
                  <span class="content" style="display: inline-block; width: 85%; overflow: hidden; white-space: nowrap; text-overflow: ellipsis" >
                    <span :class="{one: item.serialNumber === 1, second: item.serialNumber === 2, third: item.serialNumber === 3}">{{item.serialNumber}}</span>　
                    <span class="numberBox">
                      {{item.pmName}} {{item.phone}}
                    </span>
                  </span>
                </td>
                <td v-if="!$route.query.identification">
                  <span style="display: inline-block;width:60%;text-align: center">
                    {{item.totalCount}}
                  </span>
                </td>
                <td v-if="!$route.query.identification">
                  <span style="display: inline-block;width:60%;text-align: center">
                    {{item.count}}
                  </span>
                </td>
                <td :class="{'last':$route.query.identification}" style="position: relative">
                  <span class="numberBox">
                    {{item.avgScore}}
                  </span>
                  
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeadControl from "@/components/HeadControl";
import TableContentOverflow from '@/components/TableContentOverflow';
import * as Urls from "@/helper/Urls";
import moment from 'moment';
export default {
  components: {
    HeadControl,
    TableContentOverflow
  },
  data() {
    return {
      orgCode: "", //组织架构
      dataRange: [], // 时间
      checkProjectData: {}, //检查项目数据
      projectLevelData: {}, //项目等级数据
      maxNum: 0,
      maxPercent: 0,
      projectDataList: [], //新开工/已竣工
      regionDataList: [], //地区
      activeProjectName: "ALL", //项目评分排行
      projectRankList:[],   //项目评分排行榜数据
      activeDirectorName: 'ALL',  //总监评分
      directorScoreList: [],   //总监评分排行榜
      screenWidth: document.body.clientWidth,
      isH5: false,
      x:0,
      y:0,
      ClickText:'',
      TextShow:false,
      actived:0
    };
  },
  methods: {
    getText(e,val){
        let identification = this.$route.query.identification
        this.x=e.layerX+40
        this.TextShow = true
        // if( this.screenWidth <= 1920){
        //     // this.ClickText = val
        //     this.x=identification?e.layerX+20:e.layerX+40
        //     this.TextShow = true
        // }else{
        //     this.TextShow = false
        // }
    },
    init() {
      this.$refs.headControl.getDatas('month');
      this.$refs.headControl.getSysOrg();
    },
    // 获取组织架构ID
    changeVal(val) {
      this.orgCode = val
      this.getCheckProjectData()
      this.getProjectLevelData()
      this.getProjectData()
      this.getRegionData()
      this.getProjectScoreRank()
      this.getDirectorScoreRank()
    },
    // 日期改变
    changDate(val) {
      this.dataRange = val
      this.getCheckProjectData()
      this.getProjectLevelData()
      this.getProjectData()
      this.getRegionData()
      this.getProjectScoreRank()
      this.getDirectorScoreRank()
    },
    // 时间
    changePicker(val) {
      this.dataRange = val
      this.getCheckProjectData()
      this.getProjectLevelData()
      this.getProjectData()
      this.getRegionData()
      this.getProjectScoreRank()
      this.getDirectorScoreRank()
    },
    // 切换项目评分排行
    handleClick(type) {
      if(type !== this.activeProjectName){
        this.activeProjectName = type
        this.getProjectScoreRank()
      }
    },
    // 切换项目评分排行
    handleClick2(type) {
      if(type !== this.activeDirectorName) {
        this.activeDirectorName = type
        this.getDirectorScoreRank()
      }
    },
    // 检查项目折线图
    initCheckProjectChart() {
      this.checkProjectChart = this.$echarts.init(this.$refs.checkProject)
      const option = {
        textStyle: {
          fontFamily: 'PingFang-M'
        },
        title: {
          text: "检查项目",
          padding: this.isH5 ? [24, 0, 0, 20]:[24, 0, 0, 30],
          textStyle:{
            fontWeight: 'normal'
          }
        },
        tooltip: {
          show: true,
          trigger: "axis",
          formatter: function (params) {
            const str = `<div>${moment(params[0].axisValue).format("M月DD日")}</div>
                         <div>检查项目：${params[0].data}个</div>`;
            return `<div style="padding: 5px 10px; font-size: 12px">${str}</div>`;
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.checkProjectData.xAxis.data,
          axisTick: {
            show: false,
          },
          axisLine: {
            show: this.checkProjectData.series[0].data.reduce((a,b)=>a+b) === 0 ? true : false,
            lineStyle: {
              color: '#ddd'
            }
          },
          splitLine: {
            show: this.checkProjectData.series[0].data.reduce((a,b)=>a+b) === 0 ? false : true,
            lineStyle: {
              color: '#ddd'
            }
          },
          axisLabel: {
            interval: this.screenWidth < 1366 ? 'auto' : parseInt(this.checkProjectData.xAxis.data.length / 10),
            color: '#666',
            show: this.isH5 ? false:true,
            margin: 20
          },
        },
        yAxis: {
          type: "value",
          show: this.checkProjectData.series[0].data.reduce((a,b)=>a+b) === 0 ? false : true,
          name: "数量(个)",
          minInterval: 1,
          nameGap: 16,
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          splitLine: {
            show: this.checkProjectData.series[0].data.reduce((a,b)=>a+b) === 0 ? false : true,
            lineStyle: {
              color: '#ddd'
            }
          },
        },
        grid: {
          left: this.isH5 ? 45 : 60,
          right: this.isH5 ? 25 : 60,
          top: 95,
          bottom: 57,
        },
        series: [
          {
            data: this.checkProjectData.series[0].data,
            type: "line",
            smooth: true,
            symbol: "circle",
            lineStyle: {
              normal: {
                color: "#5ebbff",
                opacity: this.checkProjectData.series[0].data.reduce((a,b)=>a+b) === 0 ? 0 : 1
              },
            },
            itemStyle: {
              normal: {
                color: "#57B9FF",
                borderType: "solid",
                borderColor: "#fff",
                opacity: this.checkProjectData.series[0].data.reduce((a,b)=>a+b) === 0 ? 0 : 1
              },
            },
            areaStyle: {
              normal: {
                color: "#e6f5ff",
              },
            },
          },
        ],
      }
      this.checkProjectChart.setOption(option)
      window.addEventListener("resize", () => {
        this.isH5 ? this.checkProjectChart.resize({width: this.screenWidth - 24}) : this.checkProjectChart.resize();
      });
      this.isH5 ? this.checkProjectChart.resize({width: this.screenWidth - 24}) : this.checkProjectChart.resize();
    },
    // 项目等级柱状折线图
    initProjectLevelChart() {
      this.projectLevelChart = this.$echarts.init(this.$refs.projectLevel)
      const option = {
        textStyle: {
          fontFamily: 'PingFang-M'
        },
        title: {
          text: "项目等级",
          padding: this.isH5 ? [24, 0, 0, 20]:[24, 0, 0, 30],
          textStyle: {
            fontWeight: 'normal'
          }
        },
        grid: {
          left:  this.isH5? 20:33,
          top: 97,
          right:  this.isH5? 20:33,
          bottom: 29,
          containLabel: true,
        },
        opacity: 0.1,
        tooltip: {
          trigger: "axis",
          formatter: (params)=>{
            let message = ''
            params.reverse().forEach(function(item, index){
              if(item.seriesIndex == 1) {
                message += item.axisValue + ': ' + item.data + '个' + '<br>'
              }else{
                message += '占比: ' + item.data + '%'
              } 
            })
            return `<div style="padding: 5px 8px; font-size: 12px">${message}</div>`
          }
        },
        legend: {
          data: this.projectLevelData.legend,
          itemWidth: 40,
          itemHeight: 8,
          top: '20',
          left:this.isH5 ?'120' : '180',   
          itemGap: 20,// 每个icon之间的距离（单位px）
          textStyle: {
              fontSize: '13',            
              height: 10,
                rich: {
                a: {
                  verticalAlign: 'middle',
                },
              }
          },
        },
        xAxis: [
          {
            type: "category",
            data: this.projectLevelData.xAxis.data,
            axisPointer: {
              type: 'none'
            },
            // 分隔线
            splitLine: {
              show: this.projectLevelData.series[1].data.reduce((a,b)=>a+b) === 0 ? false : true,
              lineStyle: {
                color: "#ddd",
              },
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              show: this.projectLevelData.series[1].data.reduce((a,b)=>a+b) === 0 ? true : false,
              lineStyle: {
                color: '#ddd'
              }
            },
            axisLabel: {
              color: '#666',
              margin: 20
            }
          },
        ],
        yAxis: [
          {
            show: this.projectLevelData.series[1].data.reduce((a,b)=>a+b) === 0 ? false : true,
            // 数据显示
            type: "value",
            name: "百分比",
            min: 0,
            max: this.maxPercent,
            splitNumber: 5,
            interval: this.maxPercent / 5,
            axisLabel: {
              formatter: "{value}%",
              margin: 20,
            },
            // 坐标轴名称的文字样式
            nameTextStyle: {
              padding: [0, 65, 0, 0],
            },
            axisTick: {
              length: 16,
              lineStyle: {
                color: "#ddd",
              },
            },
            axisLine: {
              show: false,
            },
            splitLine:{
              show: false
            }
          },
          {
            show: this.projectLevelData.series[1].data.reduce((a,b)=>a+b) === 0 ? false : true,
            type: "value",
            name: "数量（个）",
            min: 0,
            max: this.maxNum,
            splitNumber: 5,
            interval: this.maxNum / 5,
            // 坐标轴名称的文字样式
            nameTextStyle: {
              padding: [0, 0, 0, 40],
            },
            axisTick: {
              length: 16,
              lineStyle: {
                color: "#ddd",
              },
            },
            axisLine: {
              show: false,
            },
            axisLabel: {
              margin: 20,
              formatter: function (value) {
                return parseInt(value);
              },
            },
            splitLine:{
              lineStyle: {
                color: "#ddd",
              },
            }
          },
        ],
        series: [
          {
            // name: "百分比",
            name: this.projectLevelData.series[0].name,
            type: "bar",
            barWidth: '60%',
            data: this.projectLevelData.series[0].data,
            itemStyle: {
              normal: {
                color: 'rgba(87, 185, 255, 0.35)',
                borderColor:this.projectLevelData.series[1].data.reduce((a,b)=>a+b)===0 ? 'rgba(87, 185, 255, 0)':'rgba(87, 185, 255, 1)',
              },
            },
            yAxisIndex: 0,
          },
          {
            // name: "个数",
            name: this.projectLevelData.series[1].name,
            type: "line",
            symbol: "rect",
            symbolSize: 9,
            hoverAnimation: false,
            data: this.projectLevelData.series[1].data,
            itemStyle: {
              normal: {
                color: "#61d9ac",
                opacity:this.projectLevelData.series[1].data.reduce((a,b)=>a+b) === 0 ? 0 : 1
              },
              emphasis: {          //突出效果配置(鼠标置于拐点上时)
                borderWidth: 3,
                borderColor: '#61d9ac',
                color: '#61d9ac',
              },
            },
            lineStyle:{
              normal:{
                opacity: this.projectLevelData.series[1].data.reduce((a,b)=>a+b)===0 ? 0 : 1
              }
            },
            yAxisIndex: 1,
          },
        ],
      }
      this.projectLevelChart.setOption(option)
      window.addEventListener("resize", () => {
        this.isH5 ? this.projectLevelChart.resize({width: this.screenWidth - 24}) : this.projectLevelChart.resize();
      });
      this.isH5 ? this.projectLevelChart.resize({width: this.screenWidth - 24}) : this.projectLevelChart.resize();
    },
    // 获取检查项目折线图数据
    getCheckProjectData() {
      let url = Urls.getEchartsPollingReportDataByTrend
      let params = {
        orgCode: this.orgCode || "",
        startTime: this.dataRange.length ? this.dataRange[0] : "",
        endTime: this.dataRange.length ? this.dataRange[1] : "",
      }
      this.$root.doPost(url, params, (server_data) => {
        // 用户没有登录
        if (!this.$root.isUserLogin(server_data)) {
          return
        }

        // 应用错误
        if (server_data.error) {
          this.$root.showGlobalError(server_data.error)
          return
        }
        this.checkProjectData = server_data.data
      })
    },
    // 获取项目等级数据
    getProjectLevelData() {
      let url = Urls.getEchartsPollingReportDataByGrade
      let params = {
        orgCode: this.orgCode || "",
        startTime: this.dataRange.length ? this.dataRange[0] : "",
        endTime: this.dataRange.length ? this.dataRange[1] : "",
        itemCode: "CONTRACT_LEVEL",
      }
      this.$root.doPost(url, params, (server_data) => {
        // 用户没有登录
        if (!this.$root.isUserLogin(server_data)) {
          return
        }

        // 应用错误
        if (server_data.error) {
          this.$root.showGlobalError(server_data.error)
          return
        }
        this.projectLevelData = server_data.data
      })
    },
    // 获取新开工/已竣工数据
    getProjectData() {
      let url = Urls.getEchartsPollingReportDataByProject
      let params = {
        orgCode: this.orgCode || "",
        startTime: this.dataRange.length ? this.dataRange[0] : "",
        endTime: this.dataRange.length ? this.dataRange[1] : "",
      }
      this.$root.doPost(url, params, (server_data) => {
        // 用户没有登录
        if (!this.$root.isUserLogin(server_data)) {
          return
        }

        // 应用错误
        if (server_data.error) {
          this.$root.showGlobalError(server_data.error)
          return
        }
        this.projectDataList = server_data.data.reportList
      })
    },
    // 获取项目地区数据
    getRegionData() {
      let url = Urls.getEchartsPollingReportDataByRegion
      let params = {
        orgCode: this.orgCode || "",
        startTime: this.dataRange.length ? this.dataRange[0] : "",
        endTime: this.dataRange.length ? this.dataRange[1] : "",
        itemCode: "ENGINEER_PROJECT_REGION",
      }
      this.$root.doPost(url, params, (server_data) => {
        // 用户没有登录
        if (!this.$root.isUserLogin(server_data)) {
          return
        }

        // 应用错误
        if (server_data.error) {
          this.$root.showGlobalError(server_data.error)
          return
        }
        this.regionDataList = server_data.data.reportList
      })
    },
    // 获取项目评分排行榜
    getProjectScoreRank() {
      let url = Urls.getEchartsPollingReportDataByProjectScore
      let params = {
        orgCode: this.orgCode || "",
        startTime: this.dataRange.length ? this.dataRange[0] : "",
        endTime: this.dataRange.length ? this.dataRange[1] : "",
        itemCode: this.activeProjectName,
      }
      this.$root.doPost(url, params, (server_data) => {
        // 用户没有登录
        if (!this.$root.isUserLogin(server_data)) {
          return
        }

        // 应用错误
        if (server_data.error) {
          this.$root.showGlobalError(server_data.error);
          return
        }
        this.projectRankList = server_data.data;
      })
    },
    // 获取总监评分排行榜
    getDirectorScoreRank() {
      let url = Urls.getEchartsPollingReportDataByDirectorScore
      let params = {
        orgCode: this.orgCode || "",
        startTime: this.dataRange.length ? this.dataRange[0] : "",
        endTime: this.dataRange.length ? this.dataRange[1] : "",
        itemCode: this.activeDirectorName,
      };
      this.$root.doPost(url, params, (server_data) => {
        // 用户没有登录
        if (!this.$root.isUserLogin(server_data)) {
          return
        }

        // 应用错误
        if (server_data.error) {
          this.$root.showGlobalError(server_data.error)
          return
        }
        this.directorScoreList = server_data.data
      })
    }
  },
  watch: {
    checkProjectData(newVal) {
      if (newVal) {
        this.initCheckProjectChart()
      }
    },
    projectLevelData(newVal) {
      if (newVal) {
        this.maxNum = Math.ceil(Math.max(...newVal.series[1].data) / 10) * 10
        this.maxPercent = Math.ceil(Math.max(...newVal.series[0].data) / 10) * 10
        this.initProjectLevelChart()
      }
    },
    screenWidth() {
      this.initCheckProjectChart()
    }
  },
  mounted() {
    if(this.$route.query.identification){
      this.isH5 = true
    }
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth; //实时宽度
        this.screenWidth = window.screenWidth;
      })();
    }; 
  }
};
</script>

<style lang="scss" scoped>
.wrap {
  margin-top: 0.29rem;
  .top {
    display: flex;
    margin-bottom: 24px;
    .t_left {
      width: 30%;
      height: 380px;
      box-sizing: border-box;
      background-color: #fff;
      -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      border-radius: 0.1rem;
      margin-right: 24px;
      .checkWrap {
        width: 90%;
        height: 50%;
        margin: 0 auto;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-around;
        padding: 0 20px;
        border-bottom: 1px solid #eee;
        .image {
          width: 75px;
          height: 75px;
          margin-right: 10%;
        }
      }
    }
    .checkProject {
      width: 70%;
      height: 380px;
      box-sizing: border-box;
      background-color: #fff;
      -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      border-radius: 0.1rem;
    }
  }
  .center {
    display: flex;
    margin-bottom: 24px;
    .c_left {
      width: 30%;
      height: 534px;;
      margin-right: 24px;
      .left_top,
      .left_bottom {
        box-sizing: border-box;
        background-color: #fff;
        -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        border-radius: 0.1rem;
      }
      .left_top {
        height: 19%;
        margin-bottom: 24px;
        display: flex;
        align-items: center;
        .itemWrap {
          width: 50%;
          height: 70%;
          box-sizing: border-box;
          border-right: 1px solid #eee;
          display: flex;
          align-items: center;
          .item {
            width: 75px;
            margin: 0 auto;
          }
        }
        .itemWrap:last-of-type {
          border: none;
        }
      }
      .left_bottom {
        height: 76.6%;
        .areaWrap {
          width: 90%;
          height: 29.5%;
          box-sizing: border-box;
          margin: 0 auto;
          border-bottom: 1px solid #eee;
          .item {
            height: 100%;
            display: flex;
            padding: 0 5%;
            justify-content: space-between;
            align-items: center;
            .location {
              font-size: 14px;
              color: #666;
              margin-bottom: 17px;
            }
            .number {
              color: #333;
            }
            .num {
              font-size: 20px;
              color: #333;
              font-weight: bold;
            }
          }
          .item:last-of-type {
            border-right: none;
          }
        }
        .areaWrap:last-of-type {
          border: none;
        }
      }
    }
    .projectGrade {
      width: 70%;
      height: 534px;;
      box-sizing: border-box;
      background-color: #fff;
      -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      border-radius: 0.1rem;
    }
  }
  .bottom {
    display: flex;
    .projectRank,
    .directorRank {
      height: 335px;
      box-sizing: border-box;
      background-color: #fff;
      -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      border-radius: 0.1rem;
      .nodata_box{
        height: calc(100% - 48px);
        display: flex;
        flex-direction: column;;
        justify-content: center;
        align-items: center;
        span{
          font-size: 16px;
          color: #ccc;
          line-height: 44px;
        }
      }
      .tablewrap{
        .content{
           cursor: pointer;
          .showTips{
                display: inline-block;
                left:0;
                top:10;
                position: absolute;
                // left: 190px;
                // top: 200px;
                padding: 6px 12px;
                background: rgba(0, 0, 0, 0.4);
                color: #fff;
                border-radius: 4px;
          }
        }
      }
    }
    .projectRank {
      width: 62%;
      margin-right: 24px;
    }
    .directorRank {
      width: 38%;
    }
  }
  .total {
    margin-bottom: 12px;
    font-size: 14px;
    color: #666;
  }
  .number {
    .num {
      font-size: 26px;
      color: #333;
    }
  }
  .p_title {
    border-bottom: none;
    font-size: 18px;
    color: #333;
    padding: 24px 0 0 30px;
  }
  .el-icon-s-data {
    color: #61d9ac;
  }
  .one{
    color: #ff0707;
  }
  .second{
    color: #ff771f;
  }
  .third{
    color: #ffa72d;
  }
  .tablist{
    width: 90%;
    margin: 18px auto 0;
    display: flex;
    li{
      padding: 5px 0;
      width: 60px;
      margin-right: 28px;
      color: #999;
      font-size: 14px;
    }
    li.active{
      color: #57B9FF;
      border-bottom: 1px solid #57B9FF;
    }
    li:hover{
      cursor: pointer;
    }
  }
  .tablewrap{
    table-layout: fixed;
    width: 90%;
    margin: 0 auto;
    color: #333;
    .table_title{
      color: #999;
      font-size: 14px;
      .last{
        text-align: right;
      }
    }
    td{
      display: inline-block;
      box-sizing: border-box;
      padding: 6px 0;
    }
    tr td:first-child{
      width: 45%;
    }
    tr td:nth-child(2){
      width: 25%;
    }
    tr td:nth-child(3){
      width: 13%;
    }
    tr td:last-child{
      width: 12%;
      position: relative;
      .numberBox{
      position: absolute;
      top: 0;
      left:70%;
    }
    }
  }
  .tablewrap.directorTable{
    tr td:first-child{
      width: 45%;
    }
    tr td:nth-child(2){
      width: 15%;
    }
    tr td:nth-child(3){
      width: 15%;
    }
    tr td:last-child{
      width: 15%;
      position: relative;
      .numberBox{
      position: absolute;
      top: 0;
      left:70%;
    }
    }
  }
}
@media screen and (max-width: 768px){
  .wrap{
    width: calc(100% - 0.24rem);
    margin: 0 auto;
    margin-top: -0.05rem;
    .top{
      flex-direction: column;
      margin-bottom: 0.12rem;
      .t_left{
        width: 100%;
        height: 250px;
        margin-bottom: 0.12rem;
        .checkWrap{
          justify-content: space-around;
        }
      }
      .checkProject{
        width: 100%;
        height: 300px;
        background-color: #fff !important;
      }
    }
    .center{
      flex-direction: column;
      margin-bottom: 0.12rem;
      .c_left{
        width: 100%;
        height: auto;
        .left_top{
          height: 85px;
          margin-bottom: 0.12rem;
        }
        .left_bottom{
          margin-bottom: 0.12rem;
          .areaWrap{
            height: 90px;
          }
          .p_title{
            padding-left: 20px;
          }
        }
      }
      .projectGrade{
        width: 100%;
        background-color: #fff !important;
      }
    }
    .bottom{
      flex-direction: column;
      .projectRank, .directorRank{
        width: 100% !important;
        .tablewrap{
        .content{
           cursor: pointer;
          .showTips{
            width: 100px;
            white-space: normal !important;
          }
        }
        }
        .p_title{
          padding-left: 20px;
        }
        .tablewrap{
          tr td.first{
            width: 70%;
          }
          tr td.last{
            width: 30%;
          }
        }
      }
      .projectRank{
        margin-bottom: 0.12rem;
      }
    }
  }
}
@media screen and (max-width: 1366px){
  .wrap{
    .tablewrap{
    table-layout: fixed;
    width: 90%;
    margin: 0 auto;
    color: #333;

    .table_title{
      color: #999;
      font-size: 14px;
      .last{
        text-align: right;
      }
    }
    td{
      display: inline-block;
      box-sizing: border-box;
      padding: 6px 0;
    }
    tr td:first-child{
      width: 40%;
    }
    tr td:nth-child(2){
      width: 27%;
    }
    tr td:nth-child(3){
      width: 20%;
    }
    tr td:last-child{
      width: 13%;
      position: relative;
      .numberBox{
      position: absolute;
      top: 0;
      left:50%;
    }
    }
  }
  .tablewrap.directorTable{
    tr td:first-child{
      width: 45%;
    }
    tr td:nth-child(2){
      width: 18%;
    }
    tr td:nth-child(3){
      width: 20%;
    }
    tr td:last-child{
      width: 15%;
      position: relative;
      .numberBox{
      position: absolute;
      top: 0;
      left:50%;
    }
    }
  }
    .bottom{
      .projectRank{
        width: 55%;
      }
      .directorRank{
        width: 45%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// pollingData.vue?540e03f4